import classNames from 'classnames'
import React, { useRef, useEffect, useCallback, } from 'react'

import { Agent, } from '@types'

interface Props {
  agents: Array<Agent>
  onAgentSelect: (agent: Agent) => () => void
  selectedAgentId?: string
  map?: naver.maps.Map
  setMap: (map: naver.maps.Map) => void
}

const MAP_INITIAL_LOCATION_COORD = {
  latitude: 36.593462851084155,
  longitude: 127.97110607545955,
}

const getMapInitialLocation = () => {
  if(typeof naver === 'undefined' || !naver.maps) {
    return null
  }

  return new naver.maps.LatLng(
    MAP_INITIAL_LOCATION_COORD.latitude,
    MAP_INITIAL_LOCATION_COORD.longitude
  )
}

function AgentListMap(props: Props) {
  const { map, setMap, agents, selectedAgentId, onAgentSelect, } = props

  const mapMarkers = useRef<Array<naver.maps.Marker>>([])

  useEffect(
    () => {
      const initMap = () => {
        const initialLocation = getMapInitialLocation()

        if(!initialLocation) {
          return
        }

        setMap(
          new naver.maps.Map('map', {
            center: initialLocation,
            zoom: 8,
          })
        )
      }

      initMap()
    },
    []
  )

  useEffect(
    () => {
      if(!map) {
        return
      }

      const initialLocation = getMapInitialLocation()

      if(!initialLocation) {
        return
      }

      if(!selectedAgentId) {
        map.setZoom(8, false)
        map.panTo(initialLocation, { duration: 200, })
      }
    },
    [ map, selectedAgentId, ]
  )

  const hideMarker = useCallback(
    (marker: naver.maps.Marker) => {
      marker.setMap(null)
    },
    []
  )

  const clearAllMarkers = useCallback(
    () => {
      if(mapMarkers.current?.length > 0) {
        for(const existMarker of mapMarkers.current) {
          hideMarker(existMarker)
        }

        mapMarkers.current = []
      }
    },
    []
  )

  useEffect(
    () => {
      if(!map) {
        return
      }

      clearAllMarkers()

      const newMarkers = []

      // @ts-ignore
      for(const [ index, agent, ] of agents.entries()) {
        if(!agent.agent_location?.coord) {
          continue
        }

        const isFocusing = agent.id.toString() === selectedAgentId
        const className = classNames('map-agent-marker', {
          working: agent.is_working,
          selected: isFocusing,
        })

        const newMarker = new naver.maps.Marker({
          map: map,
          position: {
            x: agent.agent_location.coord.longitude,
            y: agent.agent_location.coord.latitude,
          },
          icon: {
            content: `<div class='${ className }'><span>${ agent.name }</span></div>`,
            anchor: new naver.maps.Point(25, 31),
          },
          zIndex: index + 10 + (isFocusing ? 1000 : 0),
        })

        newMarker.addListener('click', onAgentSelect(agent))
        newMarkers.push(newMarker)
      }

      mapMarkers.current = newMarkers
    },
    [ map, agents, selectedAgentId, ]
  )

  return (
    <div id='map' />
  )
}

export default AgentListMap
